import '../../scss/app.scss';
import SingleProps from "./Components/SingleProps";

// You may want to change this name to the ww-your-widget-name (remeber to also change it in the twig file)
Vue.component('ww-single-props', SingleProps);
